import React from 'react';
import { Linkedin, Twitter, Youtube, Rss } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-2004">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-2005">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2006">
          <div data-id="element-2007">
            <h3 className="text-xl font-bold mb-4" data-id="element-2008">TalentMatch AI</h3>
            <p className="text-gray-400 mb-4" data-id="element-2009">
              Revolutionizing recruitment with AI-powered candidate screening
              and insights.
            </p>
            <div className="flex space-x-4" data-id="element-2010">
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-2011">
                <span className="sr-only" data-id="element-2012">LinkedIn</span>
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-2013">
                  <Linkedin size={16} data-id="element-2014" />
                </div>
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-2015">
                <span className="sr-only" data-id="element-2016">X.com</span>
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-2017">
                  <Twitter size={16} data-id="element-2018" />
                </div>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-2019">
                <span className="sr-only" data-id="element-2020">YouTube</span>
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-2021">
                  <Youtube size={16} data-id="element-2022" />
                </div>
              </a>
              <a href="https://substack.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-2023">
                <span className="sr-only" data-id="element-2024">Substack</span>
                <div className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-2025">
                  <Rss size={16} data-id="element-2026" />
                </div>
              </a>
            </div>
          </div>
          <div data-id="element-2027">
            <h4 className="text-lg font-medium mb-4" data-id="element-2028">Product</h4>
            <ul className="space-y-2" data-id="element-2029">
              {['Features', 'Pricing', 'Case Studies', 'Reviews', 'Updates'].map((item, index) => <li key={index} data-id="element-2030">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-2031">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
          <div data-id="element-2032">
            <h4 className="text-lg font-medium mb-4" data-id="element-2033">Company</h4>
            <ul className="space-y-2" data-id="element-2034">
              {['About Us', 'Careers', 'Press', 'Partners', 'Contact'].map((item, index) => <li key={index} data-id="element-2035">
                    <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-2036">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>
          <div data-id="element-2037">
            <h4 className="text-lg font-medium mb-4" data-id="element-2038">Resources</h4>
            <ul className="space-y-2" data-id="element-2039">
              {['Blog', 'Documentation', 'Help Center', 'API', 'Privacy Policy'].map((item, index) => <li key={index} data-id="element-2040">
                  <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-2041">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-2042">
          <p className="text-gray-400 text-sm" data-id="element-2043">
            © 2023 TalentMatch AI. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-2044">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-2045">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-2046">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-2047">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
};